module.exports = __webpack_public_path__ + "img/1F3AD.62a3aa86.svg";